import { ProFormDateTimePicker } from '@ant-design/pro-components'
import type { Dayjs } from 'dayjs'
import type React from 'react'
import { EditableLabel } from '../components/EditableLabel'
import { EditableShell } from '../components/EditableShell'
import { useFieldContext } from '../createAppFormHook'
import { useEditableFieldMode } from '../hooks/useEditableFieldMode'
import { useMergedFieldProps } from '../utils/mergeFieldProps'

export type DateTimePickerFieldProps = React.ComponentProps<typeof ProFormDateTimePicker>

export function DateTimePickerField(props: DateTimePickerFieldProps) {
  const fieldCtx = useFieldContext<Dayjs | undefined>()
  const { formItemProps, fieldProps, proFieldProps, className, ...rest } = props

  const editable = useEditableFieldMode<Dayjs | undefined>()

  const merged = useMergedFieldProps({
    fieldCtx,
    editable,
    props,
    fieldDefaults: {
      fieldProps: {
        onChange: (value: Dayjs | null) => fieldCtx.handleChange(value ?? undefined),
      },
    },
  })

  return (
    <EditableShell
      mode={editable.mode}
      enterEdit={editable.enterEdit}
      exitRead={editable.exitRead}
      className={className}
    >
      <ProFormDateTimePicker
        {...rest}
        label={
          <EditableLabel
            mode={editable.mode}
            enterEdit={editable.enterEdit}
            exitRead={editable.exitRead}
            onUndo={editable.undoAndExit}
            canUndo={editable.canUndo}
          >
            {rest.label}
          </EditableLabel>
        }
        proFieldProps={merged.proFieldProps}
        formItemProps={merged.formItemProps}
        fieldProps={merged.fieldProps}
      />
    </EditableShell>
  )
}
